<template>
  <v-app id="app">
    <nav>
      <v-app-bar flat app color="primary" dark>
        <v-app-bar-nav-icon @click="drawer = !drawer"></v-app-bar-nav-icon>
        <!-- <v-toolbar-title>Pet Manager - {{$route.name}}</v-toolbar-title> -->
        <v-toolbar-title dark>Pet Manager</v-toolbar-title>
      </v-app-bar>

    <v-navigation-drawer app v-model="drawer"  dark temporary >
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title class="title">Pet Manager</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-divider></v-divider>
      <v-list>
        <v-list-item v-for="item in items" :key="item.titulo" link dark :to="item.ruta">
          <v-list-item-icon>
            <v-icon>{{ item.icono }}</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title dark>{{ item.titulo }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
  </nav>
  <router-view/>
  </v-app>
</template>

<script>
export default {
  data() {
    return {
      items: [
        { titulo: "Mascotas", icono: "fa-paw", ruta: "/mascotas" },
        { titulo: "Colores",  icono: "fa-palette", ruta: "/colores"},
        { titulo: "Raza",  icono: "fa-kiwi-bird", ruta: "/razas"},
        { titulo: "Tamaño",  icono: "fa-expand-arrows-alt", ruta: "/tamanios"},
        { titulo: "Caracter",  icono: "fa-smile-beam", ruta: "/caracteres"}
      ],
      right: null,
      drawer: false
    };
  },
  created: function(){
    this.$root.mainUrl='http://localhost/pet-manager/';
  },
  mounted: function(){
    if (Modernizr.webp==true){
			this.$root.$webp='&webp=1';
    }
		else{
			this.$root.$webp='';
		}
  },
  methods:{
    getMainStyle: function(){
      if (this.$vuetify.smAndUp){
        return 'padding-left:256px';
      }
      else{
        return 'padding-left:0px';
      }
    }
  }
};
</script>
<style>
.v-list-item--active .v-list-item .v-list-item--link .theme--dark{
  color:black!important;
}
</style>